import { OptionValue, type Option } from "../../../types/option";

function getValue<TValue extends Option>(
  opt: OptionValue<TValue>,
  optionValue: string | undefined,
): string | number | TValue {
  if (typeof opt === "string" || typeof opt === "number") {
    return opt;
  }

  return (optionValue && opt[optionValue]) ?? opt;
}

export { getValue };
